import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LOGO_URL } from '../data/links';
import { EASE_OUT } from '../utils/motion';
import { LanguageToggle } from './ui/LanguageToggle';
export function Nav() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const links = [{
    href: '#sistema',
    label: t.nav.system
  }, {
    href: '#estructura',
    label: t.nav.solution
  }, {
    href: '#equipo',
    label: t.nav.team
  }, {
    href: '#servicios',
    label: t.nav.services
  }];
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-white/[0.08] bg-black/75 backdrop-blur-xl backdrop-saturate-150" data-id="element-111" data-mp="1pq0gp9k6rvng">
      <nav aria-label="Profumind" className="mx-auto flex h-14 max-w-6xl items-center justify-between px-5 md:px-6" data-id="element-112" data-mp="1yq6u6vfvwvmm">
        <a href="#top" className="flex items-center gap-2.5 outline-none focus-visible:ring-1 focus-visible:ring-cyan rounded" onClick={() => setOpen(false)} data-id="element-113" data-mp="23qbaakcvrocb">
          <img src={LOGO_URL} alt="" className="h-7 w-7 rounded-full" data-id="element-114" data-mp="1u3aaz4lqzvty" />
          <span className="text-[13px] font-semibold tracking-[0.2em] text-white" data-id="element-115" data-mp="1p50emqoaep6r">
            PROFUMIND
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-116" data-mp="1k7h2pxf2aohz">
          {links.map(link => <li key={link.href} data-id="element-117" data-mp="2hswdo21bwt6p">
              <a href={link.href} className="whitespace-nowrap text-xs text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-118" data-mp="2hw0ld9e06724">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-4" data-id="element-119" data-mp="234ia1ow390p3">
          <LanguageToggle data-id="element-120" data-mp="30k5msa76tfxr" />
          <a href="#contacto" className="hidden whitespace-nowrap rounded-full bg-cyan px-4 py-1.5 text-xs font-medium text-black transition-colors duration-150 ease-out hover:bg-cyan-light lg:inline-flex" data-id="element-121" data-mp="30lgz4yep7w0h">
            {t.nav.cta}
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? t.nav.closeMenu : t.nav.openMenu} className="-mr-1.5 rounded p-1.5 text-white/80 transition-colors duration-150 hover:text-white lg:hidden" data-id="element-122" data-mp="xy9y54a7kzu8">
            {open ? <XIcon className="h-5 w-5" data-id="element-123" data-mp="aain040emsuj" /> : <MenuIcon className="h-5 w-5" data-id="element-124" data-mp="f7scfjnsn4id" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-125" data-mp="17ras1zpft1u">
        {open && <motion.div id="mobile-menu" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: EASE_OUT
      }} className="border-t border-white/[0.06] bg-black/95 px-5 pb-8 pt-4 lg:hidden" data-id="element-126" data-mp="192c7v5ogops">
            <ul className="flex flex-col" data-id="element-127" data-mp="2aojxdlfgxxlb">
              {links.map(link => <li key={link.href} data-id="element-128" data-mp="2amfr4wu3kmhv">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-3 text-2xl font-semibold tracking-tight text-white/90 transition-colors duration-150 hover:text-white" data-id="element-129" data-mp="25pz4y86gki7f">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <a href="#contacto" onClick={() => setOpen(false)} className="mt-6 inline-flex rounded-full bg-cyan px-5 py-2.5 text-sm font-medium text-black" data-id="element-130" data-mp="2ofxdepe64dbl">
              {t.nav.cta}
            </a>
          </motion.div>}
      </AnimatePresence>
    </header>;
}